import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-imc-table',
  templateUrl: './imc-table.component.html',
  styleUrls: ['./imc-table.component.scss']
})
export class ImcTableComponent implements OnInit {
  @Input() imcValue: any;
  constructor() { }

  ngOnInit(): void {
  }

}
